import { Component, ElementRef } from '@angular/core';
import { DriverService } from './services/driver.service';
import { ConfigService } from './services/app.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {

  constructor(elm: ElementRef, private driverService: DriverService, private configService: ConfigService) {

    this.driverService.setPathDriver(elm.nativeElement.getAttribute('driverpath'));
    //this.configService.pathWebApi = elm.nativeElement.getAttribute('webApiEndPoint');
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts